import { Article, LegalScreen, Points } from '../components/legal';

/**
 * 利用規約。
 *
 * 法律上の義務ではないが、雀点は実際の金銭精算に使われるので、第3条（計算結果の
 * 免責）と第2条（共有URLの性質）は書いておきたい。
 *
 * 第7条の「故意または重大な過失による場合を除き」は外さないこと。ここを省いて
 * 「一切責任を負いません」と書き切ると、消費者契約法8条で条項ごと無効になる。
 *
 * 第5条を「金銭を賭けた麻雀は違法です」と言い切っていないのは、刑法185条に
 * 「一時の娯楽に供する物を賭けたにとどまるときは、この限りでない」という但書が
 * あるため。言い切ると事実と違う。
 */
export function TermsPage() {
  return (
    <LegalScreen title="利用規約" updatedAt="2026年9月3日">
      <p className="text-[13.5px] leading-[1.8] text-ink-soft">
        この利用規約（以下「本規約」）は、雀点（以下「本サービス」）の利用条件を定めるものです。本サービスを利用した時点で、本規約に同意したものとみなします。
      </p>

      <Article no={1} title="本サービスについて">
        <p>
          本サービスは、麻雀のスコアを記録・集計・共有するための無料のツールです。個人が趣味で運営しています。
        </p>
      </Article>

      <Article no={2} title="共有URLの取り扱い">
        <p>本サービスにアカウントはありません。グループは共有URLによって特定されます。</p>
        {/*
          ErrorBox は使わない。あれは通信や入力の失敗を出す箱で、静的な注意書きに
          流用すると「何か失敗した」と読まれる。見た目だけ借りてここに直接書く。
        */}
        <div className="rounded-r-lg border-l-[3px] border-red bg-[#FBEDEB] px-3 py-2.5 text-[12.5px] leading-relaxed text-[#8C2A24]">
          共有URLを知っている人は、誰でもそのグループを閲覧・編集・削除できます。URLの管理は利用者の責任で行ってください。SNSなど不特定多数の目に触れる場所には掲載しないでください。
        </div>
      </Article>

      <Article no={3} title="計算結果について">
        <p>
          本サービスは、入力された素点とルール設定にもとづいて精算ポイントを計算します。計算方法はルール設定の画面で確認できます。
        </p>
        <p>
          計算結果の正確性について、運営者は保証しません。金銭のやり取りを含む最終的な精算は、利用者ご自身の判断と責任で行ってください。
        </p>
      </Article>

      <Article no={4} title="禁止事項">
        <Points
          items={[
            '法令に違反する行為、または違反を助長する行為',
            '他の利用者のグループを妨害する行為',
            '自動化された手段による過度なアクセス',
            '本サービスの運営を妨げる行為',
          ]}
        />
      </Article>

      <Article no={5} title="賭博について">
        <p>
          本サービスは麻雀の記録を補助するツールであり、金銭を賭けた麻雀を推奨するものではありません。金銭を賭けた麻雀は、刑法の賭博罪に該当するおそれがあります。
        </p>
      </Article>

      <Article no={6} title="サービスの変更・停止">
        <p>
          運営者は、事前の予告なく本サービスの内容を変更し、または提供を停止することがあります。個人が運営する無料のサービスであるため、恒久的な提供やデータが失われないことを保証できません。大切な記録は別途控えをお取りください。
        </p>
      </Article>

      <Article no={7} title="免責">
        <p>
          運営者は、本サービスの利用によって利用者に生じた損害について、運営者の故意または重大な過失による場合を除き、責任を負いません。
        </p>
      </Article>

      <Article no={8} title="準拠法・管轄">
        <p>
          本規約は日本法に準拠します。本サービスに関して紛争が生じた場合、運営者の住所地を管轄する裁判所を専属的合意管轄裁判所とします。
        </p>
      </Article>

      <Article no={9} title="変更">
        <p>本規約を変更する場合は、このページを更新し、最終更新日を書き換えます。</p>
      </Article>
    </LegalScreen>
  );
}
